import { CookieTypeEnum } from './enums'

/*https://github.com/orestbida/cookieconsent#available-data-cc-actions*/

 export default function getCookieConfig(i18n, onAccept, onChange) {

    const analyticsCookiesTable = getCookies(i18n, CookieTypeEnum.Analytics);
    const essentialCookiesTable = getCookies(i18n, CookieTypeEnum.Essential);
    const marketingCookiesTable = getCookies(i18n, CookieTypeEnum.Marketing);


    const pluginConfig = {
        current_lang: 'custom',
        autoclear_cookies: true, // default: false
        onFirstAction: function (user_preferences, cookie) {/* callback triggered only once*/ },
        onAccept: function (cookie) {
            if (onAccept)
                onAccept();
        },
        onChange: function (cookie, changed_preferences) {
            if (onChange)
                onChange();
        },
        gui_options: {
            consent_modal: {
                layout: 'box',               // box/cloud/bar
                position: 'bottom right',     // bottom/middle/top + left/right/center
                transition: 'slide',           // zoom/slide
                swap_buttons: true            // enable to invert buttons
            },
            settings_modal: {
                layout: 'box',                 // box/bar
                // position: 'left',           // left/right
                transition: 'slide'            // zoom/slide
            }
        },
        languages: {
            custom: {
                consent_modal: {
                    title: `${i18n.t("Cookie usage")} 📢`,
                    description: i18n.t("CookieConsentMessage"),
                    primary_btn: {
                        text: i18n.t("Accept All"),
                        role: 'accept_all', // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: i18n.t("Reject All"),
                        role: 'accept_necessary', // 'settings' or 'accept_necessary'
                    },
                },
                settings_modal: {
                    title: i18n.t("Cookie Settings"),
                    save_settings_btn: i18n.t("Accept Selection"),
                    accept_all_btn: i18n.t("Accept All"),
                    reject_all_btn: i18n.t("Reject All"),
                    close_btn_label: i18n.t("Close"),
                    cookie_table_headers: [
                        { col1: i18n.t('Name') },
                        { col2: i18n.t('Domain') },
                        /*{ col3: 'Expiration' },*/
                        { col4: i18n.t('Description') },
                    ],
                    blocks: [
                        {
                            title: `${i18n.t("Cookie usage")} 📢`,
                            description: i18n.t("CookieUsageDesc"),
                        },
                        {
                            title: i18n.t("Essential"),
                            description: i18n.t("EssentialDesc"),
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                            cookie_table: essentialCookiesTable
                        },
                        {
                            title: i18n.t("Statistics"),
                            description: i18n.t("StatisticsDesc"),
                            toggle: {
                                value: 'analytics', // your cookie category
                                enabled: false,
                                readonly: false,
                            },
                            cookie_table: analyticsCookiesTable
                        },
                        {
                            title: i18n.t("Marketing"),
                            description: i18n.t("MarketingDesc"),
                            toggle: {
                                value: 'marketing', // your cookie category
                                enabled: false,
                                readonly: false,
                            },
                            cookie_table: marketingCookiesTable
                        },

                        {
                            title: i18n.t('CookiesMoreInformation'),
                            description: i18n.t('CookiesMoreInformationDesc'),
                        },
                    ],
                },
            },
        },
    };

    return pluginConfig;
}



 function getCookies(i18n, cookieType) {
    
    if (cookieType === CookieTypeEnum.Analytics)
        return [
            {
                col1: '^_ga', // match all cookies starting with "_ga"
                col2: 'google.com',
                /*   col3: '2 years',*/
                col4: i18n.t("_gaCookieDesc"),
                is_regex: true,
            },
            {
                col1: '_gid',
                col2: 'google.com',
                /*  col3: '1 day',*/
                col4: i18n.t("_gidCookieDesc"),
            },
            {
                col1: '_gat',
                col2: 'google.com',
                /*  col3: '1 day',*/
                col4: i18n.t("_gatCookieDesc"),
            },
            {
                col1: '_fbp',
                col2: 'google.com',
                /*  col3: '1 day',*/
                col4: i18n.t("_fbpCookieDesc"),
            }

        ];

    if (cookieType === CookieTypeEnum.Essential)
        return [
            {
                col1: 'ARRAffinity', // match all cookies starting with "_ga"
                col2: window.location.hostname,
                /*   col3: '2 years',*/
                col4: i18n.t("ARRAffinityDesc"),
                is_regex: true,
            },
            {
                col1: 'ARRAffinitySameSite',
                col2: window.location.hostname,
                /*  col3: '1 day',*/
                col4: i18n.t("ARRAffinitySameSiteDesc"),
            }
        ];
    if (cookieType === CookieTypeEnum.Marketing)
        return [
            {
                col1: 'yt.innertube::nextId', // match all cookies starting with "_ga"
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("nextIdCookieDesc"),
            },
            {
                col1: 'yt.innertube::requests', // match all cookies starting with "_ga"
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("requestsCookieDesc"),
            },
            {
                col1: 'ytidb::LAST_RESULT_ENTRY_KEY', // match all cookies starting with "_ga"
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("AST_RESULT_ENTRY_KEYCookieDesc"),
            },
            {
                col1: 'yt-remote-cast-available',
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("cast-availableCookieDesc"),
            },
            {
                col1: 'yt-remote-cast-installed',
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("cast-installedCookieDesc"),
            },
            {
                col1: 'yt-remote-connected-devices',
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("connected-devicesCookieDesc"),
            },
            {
                col1: 'yt-remote-device-id',
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("device-idCookieDesc"),
            },
            {
                col1: 'yt-remote-fast-check-period',
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("fast-check-periodCookieDesc"),
            },
            {
                col1: 'yt-remote-session-app',
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("session-appCookieDesc"),

            },
            {
                col1: 'yt-remote-session-name',
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("session-nameCookieDesc"),
            },
            {
                col1: 'CONSENT',
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("CONSENTCookieDesc"),
            }
            ,
            {
                col1: 'yt-player-bandwidth',
                col2: 'youtube-nocookie.com',
                /*   col3: '2 years',*/
                col4: i18n.t("yt-player-bandwidthCookieDesc"),
            }
        ];

}

 